export default "../../src/img/trusted-by-flutterwave.png";